import DataService from "../libs/dataservice/DataService";

class _AppDataService extends DataService {
	constructor() {
		super();
	}
}

const AppDataService = new _AppDataService();
export default AppDataService;